import React from 'react'
import { WebsiteTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/website-typography-group'
import {
  getWebsiteStylesTypographyHeading,
  getWebsiteStylesTypographyParagraph,
} from 'src/editor/store/website-settings/website-settings-selector'
import {
  updateWebsiteStylesHeadingTypography,
  updateWebsiteStylesParagraphTypography,
} from 'src/editor/store/website-settings/website-settings-actions'
import {
  WebsiteSettingsTypographyTypeEnum,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'
import { useWebsiteSettings } from 'client/store'
import { useCalculateHeadingTypography } from 'src/editor/shared/hooks/use-calculate-heading-typography'
import {
  typographyHeadingColorKeys,
  typographyParagraphColorKeys,
} from './consts'

export const WebsiteStylesSettingsTypography = () => {
  const paragraphTypography = useWebsiteSettings(
    getWebsiteStylesTypographyParagraph,
  ) as WebsiteTypographySettingsStylesInterface
  const headingTypography = useWebsiteSettings(
    getWebsiteStylesTypographyHeading,
  ) as WebsiteTypographySettingsStylesInterface

  return (
    <>
      <WebsiteTypographyGroup
        typographyObject={headingTypography}
        updateTypographyAction={updateWebsiteStylesHeadingTypography}
        typographyType={WebsiteSettingsTypographyTypeEnum.Heading}
        title="Heading"
        isFirst
        isRootSetting
        colorKeys={typographyHeadingColorKeys}
      />
      <WebsiteTypographyGroup
        typographyObject={paragraphTypography}
        updateTypographyAction={updateWebsiteStylesParagraphTypography}
        typographyType={WebsiteSettingsTypographyTypeEnum.Paragraph}
        typographyHook={useCalculateHeadingTypography}
        title="Paragraph"
        isRootSetting
        colorKeys={typographyParagraphColorKeys}
      />
    </>
  )
}
